import { render, staticRenderFns } from "./DispensationCalendar.vue?vue&type=template&id=e5a6dec8&scoped=true&"
import script from "./DispensationCalendar.vue?vue&type=script&lang=ts&"
export * from "./DispensationCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a6dec8",
  null
  
)

export default component.exports